/**
 * Button.tsx
 * ----------
 * Reusable button component.
 * - Supports gradient and custom classes.
 */


import React from 'react';

interface ButtonProps {
  onClick?: () => void;
  children?: React.ReactNode;
  className?: string;
  disabled?: boolean;
  gradient: boolean;
}

const Button: React.FC<ButtonProps> = ({
  onClick,
  children,
  className = '',
  disabled = false,
  gradient = true,
}) => {
  return (
    <button
      onClick={onClick}
      className={`
        transform min-w-max px-3 py-2 sm:py-4 sm:px-3 2xl:py-7 2xl:px-6 rounded-full 
        font-semibold text-white 
        shadow-md duration-200 hover:scale-105
        ${
          gradient
            ? 'bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700'
            : ''
        } 
        ${className}`}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

export default Button;
